/**
* Accordion HTML
*/
function customAccordionArticle(ele) {
  let toggleBtn = ele
  // Check if toggleBtn is found before proceeding
  if (toggleBtn) {
    toggleBtn.addEventListener('click', toggleAccordionBlock);
    
    /**
    * Toggle Tabs on link click
    *
    * @param {event} Event instance
    */
    function toggleAccordionBlock(event) {
      event.preventDefault();
      const toggleBtn = event.currentTarget;
      const targetContainer = toggleBtn.closest('.custom-accordion');
      const isOpen = targetContainer.classList.contains('open');
      isOpen ? closeAccordionBlock(toggleBtn) : openAccordionBlock(toggleBtn);
      
      // scroll into view the accordion on mobile
      if (window.innerWidth <= 991 && toggleBtn?.dataset?.stickyAccordion) {
        var headerOffset = 45;
        var elementPosition = toggleBtn.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }
    
    /**
    * Close Tab Container
    *
    * @param {Node} toggleFilterBtn Tab Container link to close
    */
    function closeAccordionBlock(toggleFilterBtn) {
      const targetContainer = toggleFilterBtn.closest('.custom-accordion');
      toggleFilterBtn.setAttribute('aria-expanded', false);
      Utility.toggleElement(targetContainer, 'close');
      Utility.removeTrapFocus(targetContainer);
    }
    
    /**
    * Open Tab Container
    *
    * @param {Node} toggleBtn Tab Container link to open
    */
    function openAccordionBlock(toggleBtn) {
      let targetContainer = toggleBtn.closest('.custom-accordion');
      toggleBtn.setAttribute('aria-expanded', true);
      Utility.toggleElement(targetContainer, 'open');
      if (this.accordionType == 'single') {
        let siblingBlocks = targetContainer.parentNode.querySelectorAll('.accordion__container');
        siblingBlocks.forEach(element => {
          if (element == targetContainer) {
            return;
          }
          element.classList.remove('open');
          element.querySelector('.accordion__block').classList.remove('open');
          element.querySelector('.accordion__toggle').setAttribute('aria-expanded', false);
        });
      }
      Utility.trapFocus(targetContainer);
    }
  }
}
// Call the function with the selector
document.querySelectorAll('.accordion__toggle').forEach(accordion => {
  customAccordionArticle(accordion);
});
// custom video popup
function articleCustomVideo(ele) {
  let videoModal = document.querySelector('#PopupModal-video');
  let videoSection = videoModal.querySelector('.video-container');
  let videoURL = ele.getAttribute('data-video-id');
  let container = ele.closest('.custom-video-container');
  let triggerVideo = ele.querySelector('[data-trigger-video]');
  let placementType = ele.getAttribute('data-placement');
  
  triggerVideo?.addEventListener('click', (evt) => {
    evt.preventDefault();
    let videoElement = document.createElement('video');
    videoElement.src = videoURL;
    videoElement.controls = ele.dataset.controls;
    videoElement.muted = ele.dataset.muted;
    videoElement.autoplay = ele.dataset.autoplay;
    videoElement.loop = ele.dataset.loop;
    
    videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);;
    videoSection.appendChild(videoElement);
    
    const addClassInterval = setInterval(()=> {
      if (videoSection.innerHTML != ''){
        if(placementType == 'popup'){ 
          openModal(videoModal, triggerVideo);
        }else{
          container.classList.add('playing--video');
        }
        clearInterval(addClassInterval); 
      } 
    }, 500);
  })
}
document.querySelectorAll('.custom-video').forEach(videoEle => {
  articleCustomVideo(videoEle)
});

function calculatePrice() {
  let carat = parseFloat(document.getElementById('carat').value);
  let clarity = document.getElementById('clarity').value;
  let color = document.getElementById('color').value;

  // Your pricing calculation logic goes here
  // For demonstration purposes, let's assume a basic formula
  let basePricePerCarat = 7500;
  let clarityMultiplier = getClarityMultiplier(clarity);
  let colorMultiplier = getColorMultiplier(color);
  let totalPrice = carat * basePricePerCarat * clarityMultiplier * colorMultiplier;

  document.getElementById('result').innerHTML = 'Total Price: $' + totalPrice.toFixed(2);
}

function getClarityMultiplier(clarity) {
  // Adjust multipliers based on your pricing strategy
  switch (clarity) {
    case 'IF': return 2.0;
    case 'VVS1': return 1.8;
    case 'VVS2': return 1.6;
    // Add more cases as needed
    default: return 1.0; // Default multiplier
  }
}

function getColorMultiplier(color) {
  // Adjust multipliers based on your pricing strategy
  switch (color) {
    case 'D': return 2.0;
    case 'E': return 1.8;
    case 'F': return 1.6;
    // Add more cases as needed
    default: return 1.0; // Default multiplier
  }
}
